import z from "zod"

export const keywordsAndSummaryPrompt = `Given the <article>, do the following:

1. Answer the <questions>.
2. Based on the <article> and your answers, create a JSON object with:

"summary":
  - A concise overview of the content in 1-3 sentences
  - Write objectively and directly
  - Focus solely on conveying the substance
  - Do not use phrases like "this article", "it explains", or "the text". Only describe the content itself.

"tags":
  - A list of 5-7 keywords
  - Use bigger categories that could belong to a user taxonomy
  - Avoid generic or filler words like "the" or "important"
  - Use lowercase, and "-" to separate words instead of spaces

<questions>
Q1: What is the main topic or focus of the content?
Q2: What are the key points or arguments?
Q3: Who are the 3 most relevant entities (people, organizations, or concepts) mentioned?

Example:
{
  "summary": "Cloudflare's edge DNS suffered a major global outage on July 14, 2025, when an outdated migration process triggered a legacy routing system to withdraw the 1.1.1.1 resolver IPs instead of using the newer, safer progressive rollout system. The write-up warns that one-off migrations—especially those touching critical infrastructure—introduce significant blast-radius risk, advocating for deliberate migration strategies to enhance system reliability.",
  "tags": ["cloudflare", "migrations", "dns", "programming", "devops"]
}

<article>
{{content}}`

export const keywordsAndSummaryJsonSchema = JSON.stringify({
  type: "object",
  properties: {
    summary: { type: "string" },
    tags: {
      type: "array",
      items: { type: "string" },
    },
  },
  required: ["summary", "tags"],
})

export const KeywordsAndSummarySchema = z.object({
  summary: z.string(),
  tags: z.array(z.string()),
})
